import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const options = {
  name: 'base-dialog',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    paper: {
      position: 'relative',
      maxWidth: '100%',
    },
    close: {
      position: 'absolute',
      right: 28,
      top: 28,
      color: theme.palette.grey[400],
    },
    small: {
      width: 460,
    },
    medium: {
      width: 700,
    },
    large: {
      width: 800,
    },
  }),
  options
);

export default useStyles;
